// This script handles the focus on success messages in the newsletter form to ensure accessibility.
document.addEventListener('DOMContentLoaded', function() {
  var success_messages = document.querySelectorAll('[data-newsletter-section-id]');
  success_messages.forEach(function(msg) {
    if (msg && msg.getAttribute('tabindex') === '-1') {
      // Only focus the success message of the form that ACTUALLY originated the submit.
      // `customer_posted=true` is global to every customer form on the page, so without this
      // guard a foreign submit (e.g. the hero countdown email form) would render + focus the
      // footer/modal newsletter success message and scroll-steal the page to the footer.
      // Shopify appends the submitting form's id to the URL fragment, so the originating form's
      // section id appears in location.hash; a foreign submit's hash won't contain it.
      var sectionId = msg.getAttribute('data-newsletter-section-id') || '';
      if (sectionId && window.location.hash && window.location.hash.indexOf(sectionId) !== -1) {
        setTimeout(function() {
          msg.focus();
        }, 100);
      }
    }
  });
});